import { render, staticRenderFns } from "./CreateProductModal.vue?vue&type=template&id=57c9d077&"
import script from "./CreateProductModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c9d077')) {
      api.createRecord('57c9d077', component.options)
    } else {
      api.reload('57c9d077', component.options)
    }
    module.hot.accept("./CreateProductModal.vue?vue&type=template&id=57c9d077&", function () {
      api.rerender('57c9d077', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBranches/components/CreateProductModal.vue"
export default component.exports